import { dismissToast, useToasts, type Toast } from './toast';
import { IconAlert, IconCheck, IconInfo, IconX } from './icons';

const kindStyles: Record<Toast['kind'], string> = {
  info: 'text-ink',
  success: 'text-success',
  error: 'text-danger',
};

/** Fixed toast stack. Lives in an aria-live polite region that is always mounted. */
export function Toaster() {
  const toasts = useToasts();
  return (
    <div
      aria-live="polite"
      aria-relevant="additions text"
      className="pointer-events-none fixed inset-x-0 top-0 z-50 flex flex-col items-center gap-2 px-4 pt-[calc(var(--safe-top)+0.75rem)]"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          role={t.kind === 'error' ? 'alert' : 'status'}
          className="toast-in pointer-events-auto flex w-full max-w-md items-start gap-3 rounded-2xl border border-line bg-surface py-2 pl-4 pr-1 shadow-lg"
        >
          <span className={`mt-2.5 shrink-0 ${kindStyles[t.kind]}`} aria-hidden="true">
            {t.kind === 'error' ? <IconAlert /> : t.kind === 'success' ? <IconCheck /> : <IconInfo />}
          </span>
          <p className="min-w-0 flex-1 py-2 text-[0.95rem] leading-snug whitespace-pre-line text-ink">{t.message}</p>
          <button
            type="button"
            onClick={() => dismissToast(t.id)}
            className="tap grid shrink-0 place-items-center rounded-full text-muted hover:bg-surface-2"
            aria-label="Dismiss notification"
          >
            <IconX />
          </button>
        </div>
      ))}
    </div>
  );
}
